module.exports = __webpack_public_path__ + "img/Curaçao.d4252188.svg";